import { Provider } from '@angular/core';
/**
 * tokens
 */
import { USER_AUTHZ, USER_INFO, USER_INFO_CONTROL, USER_INFO_MODEL, USER_PAYLOAD, USER_ROLE_CONTROL } from './user-tokens';

/**
 * authentication dependencies
 */
import { UserApiService } from '@identity/user/services';
import { UserService } from '@identity/user/user.service';
import { UserApiServiceProviders } from '../services/user-apis/providers-tokens/providers';

/**
 * Array of Angular providers for user services
 * @constant {Provider[]} UserServiceProviders
 * @description Configures dependency injection for all user-related services and tokens.
 * The UserService is provided as the implementation for all user interfaces.
 * 
 * @example
 * ```typescript
 * // In your module or component
 * providers: [...UserServiceProviders]
 * 
 * // Or inject specific services
 * constructor(@Inject(USER_INFO) private userInfo: IUserInfoService) {}
 * constructor(@Inject(USER_AUTHZ) private userAuthz: IUserAuthzService) {}
 * constructor(@Inject(USER_AUTHZ_CONTROL) private authzControl: IUserAuthzControlService) {}
 * ```
 */
export const UserServiceProviders: Provider[] = [
  UserService,
  UserApiService,
  { provide: USER_INFO, useExisting: UserService },
  { provide: USER_AUTHZ, useExisting: UserService },
  { provide: USER_PAYLOAD, useExisting: UserService },
  { provide: USER_ROLE_CONTROL, useExisting: UserService },
  { provide: USER_INFO_CONTROL, useExisting: UserService },
  { provide: USER_INFO_MODEL, useExisting: UserService },
]